<template>
  <v-card>
    <v-card-text>
      <v-container container--fluid grid-list-md>
         <v-row justify="space-between" align="center">
          <v-col cols="12" sm="12" md="6" v-for="(item, index) in items" :key="index">
            <v-list
              v-if="item.type === 'list'"
              :items="item.listItems"
            >
              <v-subheader>{{item.text}}</v-subheader>
              <v-list-item v-for="(listItem, index) in item.listItems" @click="" :key="index">
                <v-list-item-action>
                  <v-checkbox v-model="clientInfo[listItem.key]"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content @click="clientInfo[listItem.key] = !clientInfo[listItem.key]">
                  <v-list-item-title>{{listItem.text}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-checkbox
              v-if="item.type === 'checkbox'"
              :label="item.text"
              v-model="clientInfo[item.key]"
            ></v-checkbox>
            <v-text-field
              v-if="item.type === 'text'"
              v-model="clientInfo[item.key]"
              :label="item.text"></v-text-field>
          </v-col>
         </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  // @group EditClient
  // Client Courier Settings tab for EditClientPage
  export default {
    name: "CourierSettings",
    props: {
      // Client Object
      clientInfo: Object,
    },
    data() {
      return {
        items: [
          {
            text: 'Days(s) of the Week',
            key: 'report_sms',
            type: 'list',
            listItems: [
              {text: 'Mon', key: 'monday'},
              {text: 'Tue', key: 'tuesday'},
              {text: 'Wed', key: 'wednesday'},
              {text: 'Thu', key: 'thursday'},
              {text: 'Fri', key: 'friday'},
              {text: 'Sat', key: 'saturday'},
              {text: 'Sun', key: 'sunday'}
            ]
          },
          {
            text: 'Time(s)',
            type: 'list',
            listItems: [
              {text: 'AM', key: 'am'},
              {text: 'PM', key: 'pm'}
            ]
          },
          {text: 'Zones', key: 'zones', type: 'text'}
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Clients/CourierSettings.vue